import { z } from 'zod';

const appSchema = {
  formSchema: () => {
    return z.object({
      username: z.string().min(1, 'Username is required'),
      password: z
        .string()
        .min(8, 'Password is required and must be 8 characters long'),
    });
  },
  addReferralForm: () => {
    return z.object({
      patientId: z.number().min(1, 'Patient ID is required'),
      referralDate: z.date({ required_error: 'Referral date is required' }),
      referredBy: z.number().min(1, 'Referring provider is required'),
      urgencyLevel: z.string({ required_error: 'Urgency level is required' }),
      referredTo: z.number().min(1, 'Recipient provider is required'),
      reasonForReferral: z.string().min(1, 'Reason for referral is required'),
    });
  },
};

export default appSchema;
